/* global axios */
import ApiClient from './ApiClient';

class ConversionsAPI extends ApiClient {
  constructor() {
    super('conversions', { accountScoped: true });
  }

  show(identifier) {
    return axios.get(`${this.url}/${encodeURIComponent(identifier)}`);
  }

  showPage(identifier, page = 1) {
    return axios.get(
      `${this.url}/${encodeURIComponent(identifier)}?page=${page}`
    );
  }

  updateSettings(identifier, settings) {
    return axios.patch(
      `${this.url}/${encodeURIComponent(identifier)}/update_settings`,
      { settings }
    );
  }

  updateMapping(identifier, fieldMappings) {
    return axios.patch(
      `${this.url}/${encodeURIComponent(identifier)}/update_mapping`,
      { field_mappings: fieldMappings }
    );
  }
}

export default new ConversionsAPI();
